class StringUtils {
  static formatNumberAbbreviation(value) {
    // If value is 950 returns 950
    if(value < 1000){
        return (value).toFixed(2)
    }
    // If value is 942028 returns 942k
    if(value < 1000000){
        return (value / 1000).toFixed(1) + 'k'
    }
    // If value is 942028 returns 942k
    if(value === Infinity){
      return '0.00'
  }
    //If value is 1234938 returns 1.2m
    return (value / 1000000).toFixed(1) + 'm'
  }
  static getUSnumbersFormating(number, fullLenght = false){
    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: fullLenght ? 2 : 0,   // show decimals only when needed
      maximumFractionDigits: 2,   // cap at 2 decimals
    }).format(Number(number))
  }
  static beautifyLongNumbers(input, delimiter = ' ') {
    // Convert the input to a string if it's a number
    input = input.toString();
    // Create a regular expression to match groups of 3 characters from the end of the string
    const regex = /(\d{1,3})(?=(\d{3})+$)/g;
    // Replace the matched groups with the group followed by the delimmiter
    const spacedString = input.replace(regex, `$1${delimiter}`);
    return spacedString;
  }
  static filterByInput(input, option){
    return option.children.toLowerCase().includes(input.toLowerCase())
  }
  static isNumeric(value) {
    return !isNaN(value) && !isNaN(parseFloat(value));
  }
  static friendlyFilterName(value){
    const filterType = value.split('CrossBy')[0];
    return filterType === 'prov' 
                ? 'platform' 
                : filterType === 'wbs' 
                  ? 'website' 
                  : filterType === 'publ' 
                    ? 'publisher' 
                    : 'label'
  }
  static substractValueFromFilter(value){
    if (!value) return "";
    return value.split('CrossBy')[1];
  }
  static capitalizeFirstLetter(str) {
    if (!str) return "";
    return str.charAt(0).toUpperCase() + str.slice(1);
  }
}

export {
    StringUtils,
}